import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BaseDao } from '../dao.module';
import { EndpointOptions, EndpointService } from '../endpoint.service';
import { Estimate } from '../model/estimate';
import { PhoneIssue } from '../model/phone-issue';
import { Proceed } from '../model/proceed';

@Injectable()
export class EstimateDaoService extends BaseDao<any> {

  constructor(endpoint: EndpointService) {
    super(endpoint);

    this.configure('/estimate/', true);
  }

  put(key: string, data: any, action?: string): Observable<any> {
    let url = "";
    if (action !== undefined && action !== null) {
      url = '/s/estimate/' + key + '/?action=' + action;
    } else {
      url = '/s/estimate/' + key;
    }
    return this.handle(this.endpoint.put(url, data, this.options()));
  }

  get(key: string, entity?: string): Observable<any> {
    entity = this.getEntity(entity);
    const url = this.getUrl(entity, key);

    return this.handle(this.endpoint.getOne(url, this.getOptions()));
  }

  showPassword(key: string, entity?: string): Observable<any> {
    entity = this.getEntity(entity);
    let url = this.getUrl(entity, key);
    url += '?action=password'
    return this.handle(this.endpoint.getOne(url, this.getPasswordOptions()));
  }

  protected getOptions(): EndpointOptions {

    const mapper = estimate => {

      const issues = [];
      for (const issue of estimate.data.issues) {
        const proceeds = new Proceed(issue.proceeds.lab_proceed, issue.proceeds.genius_proceed, issue.proceeds.dealer_proceed, issue.proceeds.agent_proceed, issue.proceeds.mshp_proceed);
        issues.push(new PhoneIssue(
          issue.code,
          issue.name,
          issue.code,
          issue.brand,
          issue.model,
          issue.priority,
          issue.final_customer_price,
          issue.final_customer_price_vat,
          proceeds,
          //issue.kasko_price_vat,
        ));
      }

      const creation_date = new Date(estimate.data.creation_date._seconds * 1000);

      return new Estimate(
        estimate.key,
        estimate.data.brand,
        estimate.data.model,
        issues,
        estimate.data.ship_to_customer,
        estimate.data.state,
        estimate.data.color,
        creation_date,
        estimate.data.total_amount,
        estimate.data.total_amount_vat,
        estimate.data.shop_id,
        estimate.data.user_id,
        estimate.data.imei,
        estimate.data.unrecovered_imei,
        estimate.data.password,
        estimate.data.unrecovered_password,
        estimate.data.note,
        estimate.data.purchase_date,
        estimate.data.img_urls,
        estimate.data.delivery_times,
        estimate.data.kasko_price_vat,
        estimate.data.isOnlineEstimate,
      );
    };

    return {
      secure: true,
      mapper: mapper,
      resource: false,
    };
  }

  protected getPasswordOptions(): EndpointOptions {

    const mapper = password => {
      return password.data
    };

    return {
      secure: true,
      mapper: mapper,
      resource: false,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/core/dao-service/estimate-dao.service.ts